<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="row m-auto pb-4 acry-page-title justify-content-center">
      <img style="height: 161px; width: 755px;" src="@/assets/acrypro/top_banner.png">
    </div>
    <div class="row m-0 p-0 acry-page-title justify-content-center">お知らせ</div>
    <div class="row justify-content-center" style="margin: 40px auto; width:754px;">
      <div class="row w-100 m-2 border-dashed p-0" v-for="item in this.infoList" :key="item.text">
        <div class="col-2 p-0 acry-text-title text-start">{{item.date}}</div>
        <div class="col text-start acry-text-body">
          <a v-if="item.link" :href="item.link" class="link" target="_blank">{{item.text}}</a>
          <span v-else>{{item.text}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CenterViewInfo_Ap",
  props: {},
  data: function () {
    return {
      infoList:[
        {date:"2025.12.01", text:"ACRYTICKETサービスを導入しました", link:""},
        {date:"2025.11.10", text:"12月より料金改定を実施いたします", link:"https://www.acry.co.jp/pro/#price"},
        {date:"2025.08.18", text:"初回無料お試しサービスを導入しました", link:""},
        {date:"2025.07.03", text:"カットライン作成代行を導入しました", link:""},
        {date:"2024.03.03", text:"サンプル注文実装しました", link:""},
        {date:"2024.01.03", text:"ACRY PROリリースしました", link:""},
        // {date:"2023.01.01", text:"お知らせ2", link:"https://acry.co.jp/"},
        // {date:"2023.01.01", text:"お知らせ3", link:"https://acry.co.jp/"},
        // {date:"2023.01.01", text:"お知らせ4", link:"https://acry.co.jp/"},
      ],
    };
  },
  computed: {

  },
  created: function () {
    this.$store.commit("hideRightMenu");
  },
  components: {
  },
  methods: {


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.border-dashed{
  border-bottom: 1px dashed $border-sub-color;
}

.link{
  color: $text-main-color;
}

</style>
